export default __webpack_public_path__ + "img/57e70ab9cb0b991be8d8d6aeb778ab81.jpg";